import NotificationActions from '../../actions/NotificationActions';
import PopupActions from '../../actions/PopupActions';

import UserStore from '../../stores/UserStore';

import { endPoints as PosConstants } from '../../constants/PosConstants';
import AjaxPromises from '../../utils/AjaxPromises';

import Price from '../form/Price.react';

import ProductInformationStat from './product-information/ProductInformationStat.react';
import ProductInformationPricingTier from './product-information/ProductInformationPricingTier.react';

class ProductInformation extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading : false,
            chargeCodeArr : []
        };

        this.getPricingTier = this.getPricingTier.bind(this);
    }

    componentDidMount() {
        this.getPricingTier();
    }

    getPricingTier() {
        var self = this;

        if (!this.props.data.ChargeCodeId)
            return;

        AjaxPromises.POST(PosConstants.GET_PRICING_TIER, UserStore.getApiData({
            ChargeCodeId : self.props.data.ChargeCodeId
        })).then(res => {
            self.setState({
                loading : false ,
                chargeCodeArr : res.Data.PriceDetails || []
            });

            if (!res.Result)
                NotificationActions.error('Could not load pricing tiers');
        })
    }

    render() {
        var self = this;
        var item = this.props.data;

        return (
            <div className='popup popup__transparent'>

                <div className='product-info'>
                    <div className='product-info__block'>
                        <div
                            className='product-info__block--close'
                            onClick={() => { PopupActions.close(); }}>
                            <i className='fa fa-times' aria-hidden='true' />
                        </div>

                        <div className='product-info__title'>
                            {item.ProductDesc.length > 0 ? item.ProductDesc : <i>No Description</i>}
                        </div>

                        <div className='product-info__content'>
                            <div className='product-info__image'>
                                { item.ProductImageURL.length > 0 ?
                                    <img src={item.ProductImageURL} />
                                :
                                    <img src='/assets/id_placeholder.png' />
                                }
                            </div>

                            <div className='product-info__info'>
                                <ProductInformationStat
                                    title='Price'
                                    value={item.UnitPrice || 0}
                                    price={true} />

                                <ProductInformationStat
                                    title='Available'
                                    value={item.TotalAvailable || ''} />

                                <ProductInformationStat
                                    title='Category'
                                    value={item.MasterCategory || item.ProductCategory} />

                                { item.Strain.length > 0 &&
                                    <ProductInformationStat
                                        title='Strain'
                                        value={item.Strain} />
                                }

                                <ProductInformationStat
                                    title='Weight'
                                    value={item.UnitGrams+'g'} />

                                { item.THC && item.THC.length > 0 && item.THC !== '0' &&
                                    <ProductInformationStat
                                        title='THC'
                                        value={item.THC+'%'} />
                                }

                                { item.CBD && item.CBD.length > 0 && item.CBD !== '0' &&
                                    <ProductInformationStat
                                        title='CBD'
                                        value={item.THC+'%'} />
                                }

                                { this.state.chargeCodeArr.length > 0 &&
                                    <div className='product-info__tiers'>
                                        { this.state.chargeCodeArr.map(x => {
                                            return (
                                                <ProductInformationPricingTier
                                                    item={x} />
                                            );
                                        })}
                                    </div>
                                }
                            </div>

                            <div className='product-info__description'>
                                {item.Description}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

export default ProductInformation;


// WEBPACK FOOTER //
// ./ui_src/app/components/popup/ProductInformation.react.jsx